module.exports = __webpack_public_path__ + "img/railway_tank.52dd8fac.svg";